import { Box, Typography } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';
import { theme } from 'theme';
import { useTranslation } from 'react-i18next';

const FooterBox = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${theme.palette.background.default};
  padding: 2rem 1rem;

  .powered-by {
    font-size: 1.2rem;
    font-weight: 600;
    color: ${theme.palette.text.secondary};
  }
`;

const Footer = () => {
  const { t, i18n } = useTranslation();
  return (
    <FooterBox>
      <Typography className="powered-by">{t('Powered by')} ORDERBUDDY</Typography>
    </FooterBox>
  );
};

export default Footer;
